import React, { Component } from 'react'
import { connect } from 'react-redux'

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';

import { deleteInstalation } from './deleteActions'


const styles = theme => ({
    title : {
        display: 'inline-flex',
        verticalAlign: 'middle',
        alignItems: 'center',
        fontSize: 23,
        '& svg' : { color: '#019EAC', paddingRight : 10 }
    },
    deleteButton: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: fade(theme.palette.error.main, 0.12),
            // Reset on mouse devices
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '& svg' : { paddingRight : 10 }
    },
})

class DeleteDialog extends Component {
    state = {
        open: false
    }

    handleOnClick = () => {
        this.setState({ open: true })
    }

    handleClose = () => {
        this.setState({ open: false })
    }

    handleDelete = (event) => {
        event.stopPropagation()
        const { record, resource, basePath } = this.props;
        this.props.deleteInstalation(record, resource, basePath)
        this.setState({ open: false })
    }

    render() {
        const { open } = this.state
        const { basePath, classes, deleteInstalation, ...rest } = this.props
        return (
            <div {...rest}>
                <IconButton color="primary" onClick={this.handleOnClick}>
                    <DeleteIcon />
                </IconButton>
                <Dialog
                    open={open}
                    onClose={this.handleClose}
                    fullWidth={true}
                    maxWidth={'sm'}
                >
                    <DialogTitle>
                        <Typography className={classes.title}>
                            <DeleteIcon /> Eliminar Registro
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        ¿Está seguro que desea eliminar este registro?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="secondary">
                            Cancelar
                        </Button>
                        <Button onClick={this.handleDelete} className={classes.deleteButton}>
                            <DeleteIcon /> Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default connect(null, { deleteInstalation })(withStyles(styles)(DeleteDialog))
